import type { ComponentProps } from '@enonic/react-components'
import type { RichTextData } from '@enonic/react-components'
import * as React from 'react'
import { Icon } from '/react4xp/components/primitives/Icon'
import { Section, Container, Prose } from '../primitives'

export interface AccordionItemData extends Record<string, unknown> {
  title: string
  body?: RichTextData
}

export interface AccordionListData extends Record<string, unknown> {
  heading?: string
  items: AccordionItemData[]
}

export const AccordionList = (props: ComponentProps) => {
  const { heading, items } = props.data as AccordionListData

  return (
    <Section>
      <Container className="gap-y-12">
        {heading && (
          <h2 className="col-span-full md:col-start-3 md:col-span-8 text-3xl leading-tight text-blue-900 md:text-6xl md:leading-snug">
            {heading}
          </h2>
        )}

        <div className="col-span-full md:col-start-3 md:col-span-8 border-b border-blue-500">
          {items.map((item, index) => (
            <details key={index} className="group border-t border-blue-500">
              <summary className="group/summary flex cursor-pointer items-center justify-between px-3 py-4 list-none [&::-webkit-details-marker]:hidden">
                <span className="text-xl md:text-2xl leading-normal text-black group-open:font-bold">
                  {item.title}
                </span>
                <span
                  className="flex size-10 shrink-0 items-center justify-center bg-blue-500 text-black transition-colors group-hover/summary:bg-peach-500"
                  aria-hidden="true"
                >
                  <Icon name="add_2" className="group-open:!hidden" />
                  <Icon name="remove" className="!hidden group-open:!inline-block" />
                </span>
              </summary>
              {item.body && (
                <div className="px-3 py-4 text-xl leading-normal">
                  <Prose
                    data={item.body}
                    meta={props.meta}
                    common={props.common}
                    component={props.component}
                  />
                </div>
              )}
            </details>
          ))}
        </div>
      </Container>
    </Section>
  )
}
